module.exports = __webpack_public_path__ + "static/media/m-hunter-bear.1a1ceb57.png";